var styles = {"icons":"styles_icons__-hkFy","children":"styles_children__jItDp","actions":"styles_actions__pMckR"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
